<a [routerLink]="backUrl" class="btn-back">
  <mtg-svg-icon icon="icons-corner-left"></mtg-svg-icon>
  <ng-container *ngIf="!news.videoLink">Назад к новостям</ng-container>
  <ng-container *ngIf="news.videoLink">Назад к видео</ng-container>
</a>

<div class="panel">
  <div class="headline">
    <div class="date">{{ news.datetime | mtgDate }}, {{ news.datetime | date: 'HH:mm' }}</div>
    <div class="share">
      <mtg-share variant="icon" [url]="shareUrl"></mtg-share>
    </div>
  </div>
  <div class="content">
    <div class="title">{{ news.title }}</div>
    <div class="content" [innerHTML]="news.detailText | safe: 'html'" *ngIf="news.type !== newsTypes.video"></div>
    <div class="content" *ngIf="news.type == newsTypes.video">
      <div class="video" [mtgHeightRatio]="1.77">
        <iframe
          *ngIf="news.videoLink"
          [src]="news.videoLink | safe: 'resourceUrl'"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</div>
